export default function Section3() {
  return (
    <div className="w-full Section3">
      <div className="w-full section3-container">
        <div className="mx-auto w-[90%] md:w-[61%] text-center">
          <h2 className="my-[0.67em] text-[24px] leading-[29px] md:text-[34px] font-bold md:leading-[41px] text-[#151515]">
            <span className="text-[#DA2128]">Mean3’s WooCommerce</span>{" "}
            Development Capabilities
          </h2>
          <p className="leading-[20px] text-[#373737] text-base font-open">
            There is no one-size-fits-all approach when it comes to your
            WooCommerce development needs. We work closely with each client,
            helping them achieve their goals and dreams in a way that is
            tailored just for them!
          </p>
        </div>
        <div className="w-full md:pt-[2%] my-[4%] md:my-0 px-[20px] md:px-[30px] flex flex-col md:flex-row md:justify-evenly">
          <div className="w-full md:w-[36%] mb-5 md:mb-0">
            <ul className="w-full text-[12px] md:text-[14px] font-[500] font-open text-[#535353]">
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Research & Planning
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Custom WooCommerce Theme Design
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Full-Stack WooCommerce Development
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Advanced Customizations
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                WP REST API JSON Support
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Plugin Development & Customizations
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Migrations From Other Shopping Cart Platforms
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Third-party Integrations
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                ERP Integrations
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Product SEO
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                WooCommerce PPC and Shopping Campaigns
              </li>
            </ul>
          </div>

          <div className="w-full md:w-[36%]">
            <ul className="w-full text-[12px] md:text-[14px] font-[500] font-open text-[#535353]">
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Malware Removal
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Shipping Customizations
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Product Builder Development
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Variation-Level Custom Fields
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Marketing Strategy Planning & Development
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                WooCommerce Multi-site Dropship Platform Development
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Woo Subscriptions Fixes & Development Customizations
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                WooCommerce Website Speed Optimization
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                WooCommerce Website UX Audit Services
              </li>
              <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
                Website Maintenance & Troubleshootings
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-[30px] bt-cont text-center"><a href="https://mean3.com/contact-mean3/" className="bg-[#DA2128] font-bold rounded-[3px] text-[white] p-[10px_15px] inline-block">Request a Quote</a></div>
      </div>
    </div>
  );
}
